import styled from 'styled-components';

export const EventHighlightFeature = styled.div`
  padding: 50px 0;

  &.event_detailshighlight {
    padding-top: 50px;
    padding-bottom: 35px;
    @media (max-width: 575.98px) {
      padding: 30px 0;
    }
  }
`;

export const WShare = styled.div`
  position: relative;
  padding-right: ${({ dir }) => (dir === 'rtl' ? '' : '80px')};
  padding-left: ${({ dir }) => (dir === 'rtl' ? '80px' : '')};
  display: flex;

  @media (max-width: 991.98px) {
    padding: 0;
  }

  @media (max-width: 575.98px) {
    width: 100%;
    flex-wrap: wrap;
    margin: 0 auto;
  }
`;

export const FeatureIcon = styled.div`
  width: 25%;
  border-right: ${({ dir }) => (dir === 'rtl' ? '' : '1px solid #ebebeb')};
  border-left: ${({ dir }) => (dir === 'rtl' ? '1px solid #ebebeb' : '')};

  @media (max-width: 575.98px) {
    width: 50%;
    border: none;
  }

  @media (max-width: 991.98px) {
    &:last-child {
      border: none;
    }
  }
`;

export const FeatureIconCard = styled.div`
  padding: 1rem 2rem;
  text-align: center;
  text-transform: uppercase;
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: center;
  align-items: center;

  & > p {
    word-break: break-word;
    display: inline-block;
  }

  @media (max-width: 991.98px) {
    padding: 1rem;
  }

  @media (max-width: 575.98px) {
    padding: 0 1rem 20px;
    text-align: ${({ dir }) => (dir === 'rtl' ? 'right' : 'left')};
    border-right: none;
    align-items: ${({ dir }) => (dir === 'rtl' ? 'flex-start' : 'flex-start')};
  }

  .fcaption {
    font-family: ${({ dir }) => (dir === 'rtl' ? 'GESSTwoDWTCLight,sans-serif ' : 'DINBold ')};
    font-size: ${({ dir }) => (dir === 'rtl' ? '14px' : '12px')};
    margin: 1rem 0;
    color: #1b7bdd;
    line-height: 1;
    margin-bottom: 0px;

    @media (max-width: 575.98px) {
      margin: 0 0 14px;
      letter-spacing: ${({ dir }) => (dir === 'rtl' ? '' : '1.82px')};
    }

    &:after {
      content: '';
      width: 30px;
      height: 1px;
      display: flex;
      margin: 1rem auto;
      background: #ebebeb;

      @media (max-width: 575.98px) {
        content: '';
        display: none;
      }
    }
  }

  .flocation,
  .edate {
    font-family: ${({ dir }) => (dir === 'rtl' ? 'GESSTwoDWTCLight,sans-serif ' : 'DINRegular ')};
    font-size: ${({ dir }) => (dir === 'rtl' ? '14px' : '12x')};
    @media (max-width: 575.98px) {
      line-height: 15px !important;
      letter-spacing: ${({ dir }) => (dir === 'rtl' ? '' : '1.67px !important')};
      font-size: 10px !important;
    }
  }

  .edate {
    line-height: 1;
    margin-bottom: 0;
    font-size: ${({ dir }) => (dir === 'rtl' ? '14px' : '12px')};
    color: #000;
    text-transform: uppercase;
  }

  p {
    line-height: 1;
    margin-bottom: 0;
    font-size: 12px;
    color: #000;
  }
`;

export const FeatureIconImg = styled.div`
  display: block;

  svg {
    width: 35px;
    height: 37px;
    display: block;
    margin: 0 auto;
    min-height: 37px;

    g {
      fill: #1b7bdd;
    }

    path {
      fill: #1b7bdd;
    }

    polygon {
      fill: #1b7bdd;
    }
  }

  @media (max-width: 575.98px) {
    display: none;
  }

  &.audience {
    svg {
      width: 78px;
    }
  }
`;

export const ShareIconFeature = styled.div`
  position: absolute;
  right: 0px;
  top: 40%;

  @media (max-width: 991.98px) {
    top: -90px;
    transform: unset;
  }

  @media (max-width: 767.98px) {
    top: -95px;
    transform: unset;
  }

  div[class*='SocialMediaFloatingButtonsstyled__SocialMediaContainer-'] {
    @media (min-width: 991.98px) {
      position: absolute;
    }
  }
`;

export const SocialIcon = styled.img`
  height: 1.5rem;
  object-fit: contain;
`;
